/* eslint-disable import/prefer-default-export */

import { defineMessages } from 'react-intl';

/**
 * Allowed edition type for edition types that aren't relevant for the Institute pillar.
 * Using the description field of an edition as edition type ID's might change in the future.
 *
 * 6121bec3-ceec-412c-91bb-7362c37772a5: Docs for Sale
 * 8b523403-cf2a-464d-923c-f52ea64838da: IDFA TV
 */
export const allowedEditionTypes = ['Docs for Sale', 'IDFA TV'];

export const editionMessages = defineMessages<string>({
    '5d89ee2e-d3d4-41ed-bdb8-51bba859bf18': { defaultMessage: 'Docschool' },
});
